
     <!-- STORAGE LOCATION=========================STORAGE LOCATION=================STORAGE LOCATION===========STORAGE LOCATION -->
    <ng-container
    *ngIf="isLoadingAssetLocation === false"
    >

     <div class="storage_location assets_location tab_content" id="content6" data-tab="6">

          <div class="form_input">
            <div class="top">
              <h2 class="title">Asset Location</h2>
            </div>

            <form [formGroup]="assetLocationForm">
              <div class="input">
                <label for="">State</label>
                <select formControlName="StateId" (change)="onFilterLga($event.target.value)" class="default_input reference-form">
                  <option  *ngFor="let state of states | sortBy:'StateName'"
                  [value]="state.id">{{ state.StateName }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">LGA</label>
                <select formControlName="LgaId" (change)="onFilterCommunity($event.target.value)"  class="default_input reference-form">
                  <option *ngFor="let lga of filterLgas | sortBy:'LgaName'"
                  [value]="lga.id">{{ lga.LgaName }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">Community</label>
                <select formControlName="CommunityId" class="default_input reference-form">
                  <option *ngFor="let community of filterCommunities | sortBy:'CommunityName'"
                  [value]="community.id">{{ community.CommunityName }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">Division</label>
                <select formControlName="DivisionId" class="default_input reference-form">
                  <option *ngFor="let division of divisions"
                  [value]="division.id">{{ division.DivisionName }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">Asset Location Address</label>
                <input type="text" formControlName="AssetLocationAddress" class="default_input reference-form" />
              </div>
              <div class="btn_holder">
                <button
                  class="default_primary-button"
                  (click)="addNew(assetLocationForm.value)"
                  type="submit"
                >
                  <ng-container *ngIf="selectedIndex === null">
                    Add &rarr;
                  </ng-container>
                  <ng-container *ngIf="selectedIndex !== null">
                    Update &rarr;
                  </ng-container>
                </button>

                <div class="refresh">
                <button mat-button (click)="onReset()">
                   <i class="material-icons">
                    settings_backup_restore
                    </i>Reset</button>
                </div>
              </div>
            </form>


          </div>

    <cradua-asset-location-table
    [assetLocations]="assetLocations"
    [states]="states"
    [lgas]="lgas"
    [communities]="communities"
    [divisions]="divisions"
    (emitEdit)="onEdit($event)"
    >
    </cradua-asset-location-table>

        </div>

        <div class="acquisition_submit">
          <button *ngIf="activitySelectedValue === 'readwrite'" class="default_primary-button" (click)="onSubmit()" type="submit">
            Save
          </button>
        </div>
      </ng-container>

       <cradua-list-spinner
    *ngIf="isLoadingAssetLocation === true"
  >
  </cradua-list-spinner>
